import './App.css';
import { BrowserRouter, Routes, Route, Outlet, Navigate } from 'react-router-dom';
import Login from './component/login';
import AppSidebar from './component/AppSidebar';
import Dashboard from './component/Dashboard';
import ChangePassword from './component/ChangePassword';
import Salary from './component/Salary'; 
import SalaryForm from './component/SalaryForm';
import Employees from './component/Employees';
import EmployeesForm from './component/EmployeesForm';
import { ToastContainer } from 'react-toastify';
import { Box, CssBaseline, useMediaQuery, useTheme } from '@mui/material';
import { LicenseInfo } from "@mui/x-license";
LicenseInfo.setLicenseKey(
  "0a1ed53f76889b253d0654073db9b125Tz0xMDQxODEsRT0xNzY1NjEzNTIwMDAwLFM9cHJvLExNPXBlcnBldHVhbCxQVj0yMDIyLEtWPTI="
);

const ProtectedRoute = ({ children }) => {
  const token = sessionStorage.getItem('token');
  
  if (!token) {
    return <Navigate to="/" replace />;
  }

  return children;
};

const LayoutWithSidebar = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box sx={{ display: 'flex', width: '100vw', overflowX: 'hidden' }}>
      <CssBaseline />
      <AppSidebar isMobile={isMobile} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: isMobile ? '100%' : `calc(100% - ${theme.spacing(30)})`,
          transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
          ml: isMobile ? 0 : theme.spacing(30),
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

function App() {
  return (
    <BrowserRouter>
      <CssBaseline />
      <ToastContainer />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route element={
          <ProtectedRoute>
            <LayoutWithSidebar />
          </ProtectedRoute>
        }>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/salary" element={<Salary />} />
          <Route path="/salary-form" element={<SalaryForm />} />
          <Route path="/employees" element={<Employees />} />
          <Route path="/employees-form" element={<EmployeesForm />} />
          <Route path="/change-password" element={<ChangePassword />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;